import toast from 'react-hot-toast';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { createDenialSupport } from '@/services/denialSupport';
import { getInventories, updateInventorybyDenial } from '@/services/inventory';
import { CreateDenialSupportPayload } from '@/types/denialSupport';
import type { Inventory } from '@/types/inventory';
import type { FilterType } from '@/types/table';

export const useGetInventories = ({
	page = 1,
	limit = 15,
	enabled = true,
	columnsFilters = '[]',
	search = '',
	status = '',
	globalFilters = '[]',
	sort = '',
}: FilterType) => {
	return useQuery({
		queryFn: () =>
			getInventories(
				page,
				limit,
				columnsFilters,
				search,
				status as string | number,
				globalFilters as string,
				sort as string,
			),
		enabled,
		keepPreviousData: false,
	});
};

export const useUpdateInventory = (
	onSuccess?: (data: any) => void,
	onError?: (error: any) => void,
) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (inventoryData: {
			inventoryId: string;
			updateData: {
				'ta_DenialSupport@odata.bind': string
			};
		}) => updateInventorybyDenial(inventoryData.inventoryId, inventoryData.updateData),
		onSuccess: (data) => {
			queryClient.invalidateQueries({ queryKey: ['denialSupport'] });
			onSuccess?.(data);
		},
		onError: (error) => {
			toast.error(
				(error as any)?.response?.data?.error?.message?.message ||
					'Failed to update inventory. Please try again.',
			);
			onError?.(error);
		},
	});
};
